import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "absolute",
    top: 0,
    height: "100%",
    width: "100vw",
    overflow: "scroll",
  },
  iframe: {
    width: "100%",
    height: "100%",
    borderWidth: 0,
    paddingTop: 70,
  },
  content: {
    height: "100%",
    width: "100%",
  },
  loading: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  loadingCircle: {
    borderColor: `${theme.colors.primary} transparent transparent !important`,
  },
}));
